import React from 'react'
import { graphql, compose } from 'react-apollo'
import { translate } from 'react-i18next'
import ImgBankPhotoSelectionModal from '../../ImgBankPhotoSelection/ImgBankPhotoSelectionModal'
import PLANNER_PROFILE_BY_USER from './../../../graphql/UserByID.graphql'
import UPDATE_USER_PROFILE_QUERY from './../../../graphql/UpdatePlannerProfilePhotos.graphql'
import DELETE_FILE_QUERY from './../../../graphql/DeleteFile.graphql'
import Loader from '../../UI/Loader'
import config from '../../../config'
import { NotificationManager } from 'react-notifications'
import get from 'lodash/get'

class PhotosForm extends React.Component {
  state = {
    saving: false,
    photos: [{}, {}, {}],
    vlidationError: '',
    routeIndex: 3
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.data && nextProps.data.User && nextProps.data.User.plannerProfile && nextProps.data.User.plannerProfile.photos) {
      let photos = []
      if (nextProps.data.User.plannerProfile.photos.length < 3) {
        photos = [...nextProps.data.User.plannerProfile.photos]

        for (let i = 0; i < 3 - nextProps.data.User.plannerProfile.photos.length; i++) {
          photos.push({})
        }
      } else {
        photos = nextProps.data.User.plannerProfile.photos
      }
      this.setState({
        photos: photos
      })
    }
  }

  handleSubmit = () => {
    this.props.validate(this.state.routeIndex, true)
    console.log('this.props', this.props)
    this.setState({
      saving: true
    })
    if (this.state.photos[0].name) {
      let promises = this.state.photos
        .filter(photo => {
          return !photo.id && photo.name
        })
        .map(file => {
          return new Promise((resolve, reject) => {
            let data = new FormData()
            data.append('data', file)
            resolve(
              fetch(config.fileAPI, {
                method: 'POST',
                body: data
              })
            )
          }).then(res => res.json())
        })

      Promise.all(promises)
        .then(result => {
          return result.map(file => file.id)
        })
        .then(fileIds => {
          let photosIds = this.state.photos.filter(photo => photo.id).map(photo => photo.id)

          fileIds.forEach(id => {
            photosIds.push(id)
          })
          return this.props.updatePlannerProfile({
            variables: {
              id: this.props.data.User.plannerProfile.id,
              photosIds: photosIds
            }
          })
        })
        .then(() => {
          this.props.data.refetch()
          NotificationManager.success('Photos updated', 'Success', 5000)
          this.props.history.push('/create-guru-profile/languages')
        })
    } else {
      this.setState({ vlidationError: 'Must have at least one photo', saving: false })
    }
  }

  handleChange(e, index) {
    console.log(e)
    let photos = [...this.state.photos]

    photos[index] = e[0]
    let reader = new FileReader()
    reader.onload = function(e) {
      photos[index].src = e.target.result

      this.setState({
        photos: photos
      })
    }.bind(this)

    reader.readAsDataURL(e[0])
  }

  removePhoto = (e, index) => {
    let photos = [...this.state.photos]

    if (photos[index].url) {
      this.props
        .deleteFile({
          variables: {
            id: photos[index].id
          }
        })
        .then(result => {
          return this.props.data.refetch()
        })
    } else {
      photos[index].src = ''
    }

    this.setState({
      photos: photos
    })
  }

  closeModal = index => {
    const imgModal = {}
    imgModal['imgModal' + index] = false
    this.setState(imgModal, () => {
      console.log(this.state)
    })
  }

  render() {
    if (this.props.data.loading) {
      return <Loader showLoader={true} />
    }
    const { t, data } = this.props
    const { saving } = this.state

    if (saving) {
      return <Loader showLoader={true} />
    }
    return (
      <div className="steps-screen__form faded-container">
        <div className="steps-screen__form-title">Add Photos</div>

        <div className="form-subtitle-bold">Add your quality photos</div>
        <div className="form-subtitle-last">
          Photos increase the chance to be picked by 80%!
          <br />
          Show off your experience with 3 great photos.
        </div>

        <div className="steps-screen__form-input-area">
          {this.state.photos.map((photo, index) => (
            <div className="photo-upload" key={index}>
              <div className={photo.url || photo.src ? 'hidden' : 'photo-wrapper'}>
                <div
                  className="missing-photo"
                  onClick={e => {
                    let imgModal = {}
                    imgModal['imgModal' + index] = true
                    this.setState(imgModal, () => {
                      console.log(this.state)
                    })
                  }}
                >
                  <i className="icon-plus" />
                </div>

                <ImgBankPhotoSelectionModal
                  id={'file' + index}
                  user={data.User}
                  isOpen={this.state['imgModal' + index]}
                  index={index}
                  onClose={this.closeModal}
                  onFileChange={e => this.handleChange(e, index)}
                  t={t}
                />
              </div>

              <div
                className={photo.url || photo.src ? 'photo-upload__image-wrapper' : 'hidden'}
                style={{
                  backgroundImage: `url(${photo.url || photo.src})`,
                  backgroundSize: 'cover'
                }}
              />
              <button
                className={'photo-upload__remove-btn' + (photo.url || photo.src ? '' : ' hidden')}
                onClick={e => this.removePhoto(e, index)}
              >
                <i className="icon-plus" />
                Remove
              </button>
            </div>
          ))}
        </div>
        <div className="form-subtitle-last">Please select at least one picture.</div>
        <small className="text-danger">{this.state.vlidationError}</small>
        <button onClick={() => this.handleSubmit()} className="btn btn-lg btn-primary btn-danger">
          {t('main:save_continue')}
        </button>
      </div>
    )
  }
}

export default compose(
  translate('guide'),
  graphql(UPDATE_USER_PROFILE_QUERY, {
    name: 'updatePlannerProfile'
  }),
  graphql(PLANNER_PROFILE_BY_USER, {
    options: props => ({
      variables: {
        id: get(props, 'user.id', '')
      },
      options: {
        fetchPolicy: 'network-only'
      }
    })   
  }),
  graphql(DELETE_FILE_QUERY, {
    name: 'deleteFile'
  })
)(PhotosForm)



// WEBPACK FOOTER //
// src/components/Guru/CreateGuruProfile/PhotosForm.jsx